module.exports = {"pathContext":{"name":"LabTrendRange","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"max","type":{"kind":"SCALAR","name":"Float","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"min","type":{"kind":"SCALAR","name":"Float","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-lab-trend-range.json
// module id = 1829
// module chunks = 10035159985014